// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { WIZARD_TWINGRAPH_QUERIES } from './WizardConstants';

export const dispatchGetAgingLawsTwingraphQueriesResults = (datasetId, scenarioData) => ({
  type: WIZARD_TWINGRAPH_QUERIES.INITIALIZE_AGING_LAWS_TWINGRAPH_QUERIES,
  payload: { datasetId, scenarioData },
});

export const dispatchSetAgingLawsQueriesResult = (scenarioId, result, key) => ({
  type: WIZARD_TWINGRAPH_QUERIES.PROCESS_AGING_LAWS_TWINGRAPH_QUERIES,
  payload: { scenarioId, result, key },
});

export const dispatchAddTechVar = (techVar, scenarioId) => ({
  type: WIZARD_TWINGRAPH_QUERIES.ADD_TECHNICAL_VAR,
  payload: { techVar, scenarioId },
});

export const dispatchResetTechnicalVars = (scenarioId) => ({
  type: WIZARD_TWINGRAPH_QUERIES.RESET_TECHNICAL_VARS,
  payload: { scenarioId },
});

export const dispatchInitializeGanttTwingraphQueries = (datasetId, scenarioData) => ({
  type: WIZARD_TWINGRAPH_QUERIES.INITIALIZE_GANTT_CHART_TWINGRAPH_QUERIES,
  payload: { datasetId, scenarioData },
});

export const dispatchInitializeGisementTwingraphQueries = (selectedGisementTablesMapping, datasetId, scenarioData) => ({
  type: WIZARD_TWINGRAPH_QUERIES.INITIALIZE_SELECTED_GISEMENT_TWINGRAPH_QUERIES,
  payload: { selectedGisementTablesMapping, datasetId, scenarioData },
});

export const dispatchUpdateGisementData = (scenarioId, result, key, gisementName) => ({
  type: WIZARD_TWINGRAPH_QUERIES.PROCESS_TECHNICAL_POLICY_TWINGRAPH_QUERIES,
  payload: { scenarioId, result, key, gisementName },
});

export const dispatchSetNewTableNamesMapping = (scenarioId, gisement, tableNamesMapping) => ({
  type: WIZARD_TWINGRAPH_QUERIES.SET_NEW_TABLES_MAPPING,
  payload: { scenarioId, gisement, tableNamesMapping },
});

export const dispatchDeleteGisement = (scenarioId, gisementName) => ({
  type: WIZARD_TWINGRAPH_QUERIES.DELETE_GISEMENT,
  payload: { scenarioId, gisementName },
});

export const dispatchUpdateTechnicalPolicy = (scenarioId, key, data) => ({
  type: WIZARD_TWINGRAPH_QUERIES.UPDATE_TECHNICAL_POLICY,
  payload: { scenarioId, key, data },
});

export const dispatchSetWizardQueriesStatus = (status) => ({
  type: WIZARD_TWINGRAPH_QUERIES.SET_TWINGRAPH_QUERIES_STATUS,
  status,
});

export const dispatchGetDataVectorTwingraphQueriesResult = (datasetId, scenarioData) => ({
  type: WIZARD_TWINGRAPH_QUERIES.INITIALIZE_DATA_VECTOR_TWINGRAPH_QUERIES,
  payload: { datasetId, scenarioData },
});
